import { ContentPreview, Material } from '@app/store/shared';
import { CourseDto, InstructorDto } from './course.dto';
import { LessonType } from '../../lesson';

export const sortedLessonsTypes: LessonType[] = ['video', 'text', 'audio'];
export class Course {
    id: string;
    name: string;
    placeholder: {
        landscape: string;
        portrait: string;
    };
    description: string | null;
    duration: number; // in seconds
    rating: number; // average rating
    participants: number; // number of participants
    instructor: Instructor;
    objectives: string[]; // learning objectives
    tags: string[]; // tags associated with the course
    lessonsTypes: LessonType[]; // array of lesson types
    sortedLessonTypes: LessonType[];
    materials: Material[]; // list of course materials
    moduleNext: ContentPreview; // next module to be completed
    modules: ContentPreview[];

    constructor(data: CourseDto) {
        this.id = data.id;
        this.name = data.name;
        this.placeholder = {
            landscape: data.placeholder,
            portrait: data.placeholderPortrait,
        };
        this.description = data.description.trim().length === 0 ? null : data.description;
        this.duration = data.duration;
        this.rating = data.rating;
        this.participants = data.participants;
        this.instructor = new Instructor(data.instructor);
        this.objectives = [...data.objectives];
        this.tags = [...data.tags];
        this.lessonsTypes = data.lessonsTypes;
        this.materials = data.materials.map((material) => new Material(material));
        this.moduleNext = new ContentPreview(data.moduleNext);
        this.modules = data.modules.map((module) => new ContentPreview(module));
        this.sortedLessonTypes = [...(this.lessonsTypes ?? [])].sort((a, b) => sortedLessonsTypes.indexOf(a) - sortedLessonsTypes.indexOf(b)) || [];
    }
}

export class Instructor {
    firstname: string;
    lastname: string;
    degree: string;
    university: string;
    image: string;

    constructor(data: InstructorDto) {
        this.firstname = data.firstname;
        this.lastname = data.lastname;
        this.degree = data.degree;
        this.university = data.university;
        this.image = data.image;
    }
}
